<template>
<div class="chapter">
<div class="inner_page">
<div id="fm05">
<a id="pagev">
<p class="dedication">For Grace and Jack</p>
</a></div><a id="pagev">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?6fc10741